import type { Artifact } from "@lumen/shared";
import { api } from "../../api";

/** Conversation artifacts remain referenceable before they are saved to the vault. */
export async function loadArtifactReferences(conversationId?: string) {
  const sources = await Promise.allSettled([
    ...(conversationId
      ? [
          api<{ artifacts: Artifact[] }>(
            `/conversations/${encodeURIComponent(conversationId)}/artifacts`,
          ).then((response) => response.artifacts),
        ]
      : []),
    api<Artifact[]>("/artifacts"),
  ]);
  const loaded = sources.flatMap((source) =>
    source.status === "fulfilled" && Array.isArray(source.value)
      ? [source.value]
      : [],
  );
  if (!loaded.length) throw new Error("Artifacts could not be loaded");
  // Show local artifacts first, with only one entry for saved local artifacts.
  return [
    ...new Map(
      loaded.flat().map((artifact) => [artifact.id, artifact]),
    ).values(),
  ];
}
